import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user?.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-radial-spotlight grain relative px-6">
      <form onSubmit={submit} className="luxe-card p-10 w-full max-w-md relative z-10">
        <div className="flex items-center gap-3 mb-2">
          <Lock size={20} className="text-[var(--gold)]" />
          <span className="text-[0.65rem] uppercase tracking-[0.3em] text-[var(--gold)]">Area Riservata</span>
        </div>
        <h1 className="font-serif text-4xl text-white mb-2">Accedi</h1>
        <p className="text-sm text-white/50 mb-8">Accesso al pannello di gestione Affari Oro.</p>

        <label className="block text-xs uppercase tracking-widest text-white/40 mb-2">Email</label>
        <input data-testid="admin-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border border-white/15 px-4 py-3 text-white focus:border-[var(--gold)] outline-none mb-5" />

        <label className="block text-xs uppercase tracking-widest text-white/40 mb-2">Password</label>
        <input data-testid="admin-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border border-white/15 px-4 py-3 text-white focus:border-[var(--gold)] outline-none mb-8" />

        <button data-testid="admin-login-btn" type="submit" disabled={loading} className="btn-gold w-full justify-center">
          {loading ? "Accesso..." : "Accedi"}
        </button>
      </form>
    </div>
  );
}
